import { useHasCrremPathwayData } from "./useHasCrremPathwayData";
import { useHasLegacyCrremData } from "./useHasLegacyCrremData";

export type CrremChartSource = "empty" | "legacy" | "new";

export const useCrremChartSource = (projectId: string): CrremChartSource | undefined => {
  const newSource = useHasCrremPathwayData(projectId);
  const waitForLegacy = !newSource.hasData && !newSource.isLoading;
  const legacySource = useHasLegacyCrremData(projectId, waitForLegacy);

  if (newSource.hasData) return "new";
  if (newSource.isLoading) return undefined;
  if (legacySource.hasData) return "legacy";
  if (legacySource.isLoading) return undefined;
  return "empty";
};
